import { useTranslation } from '@/i18n';
import { Label, ListViewBody } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { memo, useMemo } from 'react';
import { useTransactionDetailSectionContext } from '../context/TransactionDetailSectionContext';
import { useFieldRenderer } from '../hooks/useFieldRenderer';
import styles from '../TransactionDetailSection.module.scss';
import { TransactionCardProps } from '../types';
import { TransactionFieldItem } from './TransactionFieldItem';

const cx = classnames.bind(styles);

export const TransactionCard = memo(
  ({ transaction, index }: TransactionCardProps) => {
    const { t } = useTranslation();
    const { fields } = useTransactionDetailSectionContext();
    const { renderField } = useFieldRenderer(transaction, index);

    const allFields = useMemo(() => {
      const fieldList = fields || [];
      return fieldList.map(renderField);
    }, [fields, renderField]);

    const headerTitle = useMemo(
      () => t('transactionDetail_title', { index: index + 1 }),
      [t, index]
    );

    return (
      <ListViewBody className={cx('container')} key={transaction.id}>
        <div className={cx('listViewContainer')}>
          <div className={cx('listViewHeader')}>
            <Label
              labelContentClassName={cx('listViewHeaderTitle')}
              text={headerTitle}
            />
          </div>
        </div>
        {allFields.map((fieldProps) => (
          <TransactionFieldItem
            key={fieldProps.key}
            title={fieldProps.title}
            content={fieldProps.content}
            titleTooltip={fieldProps.titleTooltip}
            titleTooltipIcon={fieldProps.titleTooltipIcon}
            contentTooltip={fieldProps.contentTooltip}
            contentTooltipIcon={fieldProps.contentTooltipIcon}
            isSelected={fieldProps.isSelected}
          />
        ))}
      </ListViewBody>
    );
  }
);

TransactionCard.displayName = 'TransactionCard';
